<template>
  <div class="AtlasUnsupported">
    <p>We're sorry, it looks like your browser is not supported.</p>
    <p>
      Please try the latest version of
      <a href="https://www.mozilla.org/en-US/firefox/">Firefox</a>,
      <a href="https://www.google.com/chrome/">Chrome</a> or
      <a href="https://support.apple.com/downloads/safari">Safari</a>.
    </p>
  </div>
</template>

<style lang="scss">
.AtlasUnsupported {
  padding: 200px 30px;
  background-color: #f0f0f0;
  text-align: center;
}
</style>
